export const responseStatus = {
  200: "SUCCESS",
};
